import { Link } from 'react-router-dom';

/**
 * The Lotus Living lockup (rosette + wordmark). Three colourways live in /public so the
 * same mark sits on a photograph, on white and on charcoal without a filter hack.
 */
export function Logo({ tone = 'bronze', className = 'h-8', to = '/' }: { tone?: 'bronze' | 'white' | 'ink'; className?: string; to?: string }) {
  const src = tone === 'white' ? '/logo-white.svg' : tone === 'ink' ? '/logo-ink.svg' : '/logo.svg';
  return (
    <Link to={to} className="inline-flex shrink-0 items-center" aria-label="Lotus Living">
      <img src={src} alt="Lotus Living" className={`${className} w-auto`} draggable={false} />
    </Link>
  );
}

export function LotusMark({ className = 'h-6 w-6' }: { className?: string }) {
  return <img src="/lotus-mark.svg" alt="" className={className} draggable={false} />;
}
